import React, { createContext, useContext, useEffect, useState } from "react";
import { api, saveAuth, clearAuth, getStoredUser, getToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getStoredUser());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = getToken();
    if (t && !user) {
      setLoading(true);
      api.get("/auth/me")
        .then((r) => { setUser(r.data); localStorage.setItem("hw_user", JSON.stringify(r.data)); })
        .catch(() => clearAuth())
        .finally(() => setLoading(false));
    }
    // eslint-disable-next-line
  }, []);

  const signup = async (data) => {
    const r = await api.post("/auth/signup", data);
    saveAuth(r.data.token, r.data.user);
    setUser(r.data.user);
    return r.data.user;
  };
  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    saveAuth(r.data.token, r.data.user);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => { clearAuth(); setUser(null); };

  return (
    <AuthCtx.Provider value={{ user, loading, signup, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
